

export const BigRedButton=({text})=>{
    
    
    return(
        <div className="big-red-button collapse">
            <p>{text}</p>
        </div>
    )
}